export default __webpack_public_path__ + "static/media/empty_cart.498b68fd.svg";